import { render, staticRenderFns } from "./RoomService.vue?vue&type=template&id=1cf23fc2"
import script from "./RoomService.vue?vue&type=script&lang=js"
export * from "./RoomService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports